export default {
  "pl": {
    "customer": {
      "actions": {
        "addCompany": "Dodaj firmę",
        "addCustomer": "Dodaj klienta",
        "addSecondaryContact": "Dodaj dodatkową osobę kontaktową",
        "add_email_address": "Dodaj adres e-mail",
        "cancel": "Cofnij",
        "changeProfilePicture": "Zmień zdjęcie profilowe",
        "createNewCustomer": "Dodaj nowego klienta…",
        "goToCustomerProfile": "Przejdź do strony kontaktu z klientem",
        "new": "Nowy klient",
        "profilePictureFormat": "Minimalne wymiary obrazu to <strong>300 ⨯ 300 px</strong>",
        "removeCompany": "Usuń szczegółowe informacje o firmie",
        "removeCustomer": "Anuluj przypisanie tego klienta",
        "removeSecondaryContact": "Usuń dodatkową osobę kontaktową",
        "save": "Zapisz",
        "searchCustomer": "Wyszukaj klienta",
        "submit": "Zapisz",
        "uploadProfilePicture": "Prześlij zdjęcie profilowe"
      },
      "attributes": {
        "address": "Adres",
        "birth_date": "Data urodzenia",
        "categories": {
          "enduser": "Nabywca zajmujący lokal",
          "investor": "Inwestor"
        },
        "category": "Rodzaj klienta",
        "company_name": "Nazwa firmy",
        "company_vat": "Numer VAT",
        "email_address": "E-mail",
        "email_address_secondary": "E-mail drugiego kontaktu",
        "email_notifications_interval": {
          "daily": "Raz dziennie (ok. południa)",
          "hourly": "Co godzinę",
          "twice_daily": "Dwa razy dziennie (w południe i wieczorem)",
          "weekly": "Raz w tygodniu (w poniedziałek w południe)"
        },
        "first_name": "Imię",
        "iban": "IBAN",
        "internal_note": "Notatka do użytku wewnętrznego",
        "language": "Język",
        "last_name": "Nazwisko",
        "phone_landline": "Numer stacjonarny",
        "phone_mobile": "Numer telefonu komórkowego",
        "status": "Status"
      },
      "labels": {
        "customerAddedState": "<b>Nie zaproszono.</b> Zaproszenie zostanie wysłane, kiedy klient {name} uzyska dostęp do przypisanej jednostki.",
        "customerAddedStateNoEmailAddress": "<b>Brak znanego adresu e-mail.</b> Adres e-mail jest potrzebny do przyznania {name} dostępu do przypisanej jednostki.",
        "hasAccessToUnit": "Ma dostęp online do jednostki",
        "information": "Twoje informacje",
        "noCustomersYet": "Brak klientów korzystających z platformy",
        "noEmailAddress": "Brak adresu e-mail",
        "noUnits": "Nie przypisano żadnych jednostek",
        "notSharedWithCustomer": "Niewidoczne dla klienta",
        "notificationDisclaimer": "Otrzymasz powiadomienie za każdym razem, gdy pojawią się nowe treści dla ciebie. Powiadomienia, których nie wyświetlisz na platformie, zostaną wysłane razem w wiadomości e-mail. Poniżej możesz wyłączyć powiadomienia dotyczące konkretnych tematów i zmniejszyć lub zwiększyć częstotliwość otrzymywania wiadomości e-mail.",
        "onPlatform": "Na platformie",
        "otherSettings": "Inne ustawienia",
        "password": "Hasło",
        "primaryContact": "Twoje szczegółowe dane",
        "secondaryContact": "Dodatkowa osoba kontaktowa",
        "sharedWithCustomer": "Widoczne dla klienta",
        "units": "Jednostki",
        "viaEmail": "E-mailem"
      },
      "messages": {
        "integrationUpdateInformation": "Jeśli chcesz zaktualizować swoje dane, skontaktuj się z nami."
      },
      "toasts": {
        "birthday": "Wszystkiego najlepszego, {first_name}!",
        "create": "Dodano klienta",
        "delete": "Usunięto klienta",
        "update": "Zaktualizowano dane klienta"
      },
      "validation": {
        "needFirstName": "Należy podać imię",
        "needFirstNameSecondary": "Należy podać imię dodatkowej osoby kontaktowej",
        "needLastName": "Należy podać nazwisko",
        "needLastNameSecondary": "Należy podać nazwisko dodatkowej osoby kontaktowej"
      }
    }
  }
}
